import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { PoModule } from "@po-ui/ng-components";
import { PoPageDynamicEditModule, PoPageDynamicTableModule } from "@po-ui/ng-templates";
import { SharedModule } from "../shared/shared.module";
import { EmpresaSocioComponent } from "./empresa-socio/empresa-socio.component";
import { LoginModule } from "./login/login.module";
import { DashModule } from "./dash/dash.module";
import { UserModule } from "./users/user.module";
import { AcessoModule } from "./acesso/acesso.module";
import { DispositivosModule } from "./dispositivos/dispositivos.module";
import { SalasModule } from "./salas/salas.module";
import { ConfigModule } from "./config/config.module";
import { EmpresaModule } from "./empresas/empresa.module";
import { ReportsModule } from "./reports/reports.module";
import { PasswordRecoveryModule } from "./password-recovery/password-recovery.module";
import { AuthCallbackModule } from "./auth-callback/auth-callback.module";
import { RazaoContabilModule } from "./razao-contabil/razao-contabil.module";
import { BalanceteModule } from "./balancete/balancete.module";
import { AtasSociosModule } from "./atas-socios/atas-socios.module";
import { PendenciasModule } from "./pendencias/pendencias.module";
import { ContabilOutrosModule } from "./contabil-outros/contabil-outros.module";
import { MedicosDominioModule } from "./medicos-dominio/medicos-dominio.module";
import { NotasFaturamentoModule } from "./notas-faturamento/notas-faturamento.module";
import { ProcessamentoFaturasModule } from "./processamento-faturas/processamento-faturas.module";
import { CertificadoDigitalModule } from "./certificado-digital/certificado-digital.module";
import { ChavesAcessoModule } from "./chaves-acesso/chaves-acesso.module";
import { ConciliacaoFornecedoresModule } from "./conciliacao-fornecedores/conciliacao-fornecedores.module";
import { ConvencoesSindicaisModule } from "./convencoes-sindicais/convencoes-sindicais.module";
import { AcumuladoresModule } from "./acumuladores/acumuladores.module";


@NgModule({
  declarations: [
    EmpresaSocioComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PoModule,
    PoPageDynamicTableModule,
    PoPageDynamicEditModule,
    SharedModule,
    DashModule,
    AuthCallbackModule,
    LoginModule,
    UserModule,
    AcessoModule,
    DispositivosModule,
    SalasModule,
    EmpresaModule,
    ConfigModule,
    ReportsModule,
    PasswordRecoveryModule,
    RazaoContabilModule,
    BalanceteModule,
    AtasSociosModule,
    PendenciasModule,
    MedicosDominioModule,
    NotasFaturamentoModule,
    ContabilOutrosModule,
    ProcessamentoFaturasModule,
    CertificadoDigitalModule,
    ChavesAcessoModule,
    ConciliacaoFornecedoresModule,
    ConvencoesSindicaisModule,
    AcumuladoresModule
  ],
  exports: [

  ]
})
export class HomeModule { }
